module.exports = __webpack_public_path__ + "static/media/logo.1de2b001.svg";